<template>
  <div :class="[
    'input-block-container',
    ['optins', 'clientTypology', 'preferredBrand', 'brandAwareness'].includes(formConfig.name) ? 'align-optins' : null
  ]">
    <div :style="formConfig.duplicate_element ? 'display: flex' : null">
      <component v-bind="formConfig" :is="formTypeToComposantName(formConfig.type)" ref="formGeneratorField" :class="{
    'input-instance-block-inline': formConfig.displayInline && formConfig.type === 'input-block',
    'input-instance-block': !formConfig.displayInline && formConfig.type === 'input-block',
    hidden: formConfig.hidden
  }" :style="formConfig.duplicate_element ? 'width: 87%;margin-right: 13px' : null" :lastIndex="lastIndex && lastIndex[formConfig.name]
    ? lastIndex[formConfig.name]
    : typeof lastIndex === 'number'
      ? lastIndex
      : 0
    " :checkBoxUniq="checkBoxUniq" :checkboxChildrenValue="checkboxChildrenValue" @add-data="
    $emit(
      'addData',
      formConfig.duplicate_element
        ? { ...$event, ...{ duplicateElement: formConfig.duplicateElementIndex } }
        : $event
    )
    " @add="$emit('add', $event)" @delete="$emit('delete', $event)" @clear="$emit('clear', $event)"
        @set-default="$emit('setDefault', $event)" @only-one-selected-name="$emit('onlyOneSelectedName', $event)"
        @check-box-children-show="$emit('checkBoxChildrenShow', $event)" />

      <AddRemoveButtons v-if="formConfig.duplicate_element" :showAdd="(lastIndex[formConfig.name] === formConfig.duplicateElementIndex ||
    lastIndex === formConfig.duplicateElementIndex) &&
    formConfig.duplicate_element > formConfig.duplicateElementIndex
    " isComponent :showDelete="lastIndex[formConfig.name] > 0"
        :lastIndex="lastIndex && lastIndex[formConfig.name] ? lastIndex[formConfig.name] : 0"
        @add="$emit('addElement', { name: formConfig.name, duplicateElementIndex: formConfig.duplicateElementIndex })"
        @delete="
    $emit('deleteElement', { name: formConfig.name, duplicateElementIndex: formConfig.duplicateElementIndex })
    " />
    </div>

    <div v-if="formConfig.children" :class="[
    formConfig.displayInline ? 'input-instance-block-inline' : 'input-instance-block',
    formConfig.type === 'input-block' || formConfig.type === 'input-block-checkbox' ? 'block-left-margin' : null
  ]">
      <FormGeneratorComponent v-for="field in formConfig.children" :key="field.uniqId" ref="formGeneratorComponent"
        :formConfig="checkSubChildren(field)" :formData="formData" :checkBoxUniq="checkBoxUniq"
        :lastIndex="lastIndex && lastIndex[formConfig.name] ? lastIndex[formConfig.name] : lastIndex ? lastIndex : 0"
        :checkboxChildrenValue="checkboxChildrenValue && checkboxChildrenValue[formConfig.name] !== null
    ? checkboxChildrenValue[formConfig.name]
    : null
    " @add-data="formatAddData($event)" @only-one-selected-name="$emit('onlyOneSelectedName', $event)"
        @check-box-children-show="$emit('checkBoxChildrenShow', $event)" @add-element="$emit('addElement', $event)"
        @delete-element="$emit('deleteElement', $event)" />
    </div>
  </div>
</template>

<script>
import BasicTextInput from '@/components/GenericComponents/Form/BasicTextInput.vue'
import BasicNumberInput from '@/components/GenericComponents/Form/BasicNumberInput.vue'
import BasicCheckbox from '@/components/GenericComponents/Form/BasicCheckbox.vue'
import BasicDateInput from '@/components/GenericComponents/Form/BasicDateInput.vue'
import BasicFileInput from '@/components/GenericComponents/Form/BasicFileInput.vue'
import BasicPasswordInput from '@/components/GenericComponents/Form/BasicPasswordInput.vue'
import BasicEmailInput from '@/components/GenericComponents/Form/BasicEmailInput.vue'
import BasicRadioInput from '@/components/GenericComponents/Form/BasicRadioInput.vue'
import BasicRangeInput from '@/components/GenericComponents/Form/BasicRangeInput.vue'
import BasicSelect from '@/components/GenericComponents/Form/BasicSelect.vue'
import BasicAutocomplete from '@/components/GenericComponents/Form/BasicAutocomplete.vue'
import BasicTextArea from '@/components/GenericComponents/Form/BasicTextArea.vue'
import BasicTimeInput from '@/components/GenericComponents/Form/BasicTimeInput.vue'
import FormFullScreen from '@/components/GenericComponents/Form/FormFullScreen.vue'
import BetweenDateFullScreen from '@/components/GenericComponents/Form/BetweenDateFullScreen.vue'
import BetweenMinMax from '@/components/GenericComponents/Form/BetweenMinMax.vue'
import FormSearchCustomer from '@/components/GenericComponents/Form/FormSearchCustomer.vue'
import BasicScanInput from '@/components/GenericComponents/Form/BasicScanInput.vue'
import InputBlockCheckbox from '@/components/GenericComponents/Form/InputBlockCheckbox.vue'
import CheckboxInput from '@/components/GenericComponents/Form/CheckboxInput.vue'
import CustomNumberInput from '@/components/GenericComponents/Form/CustomNumberInput.vue'
import CustomPhoneInput from '@/components/GenericComponents/Form/CustomPhoneInput.vue'
import CustomLanguageInput from '@/components/GenericComponents/Form/CustomLanguageSelect.vue'
import SpanElement from '@/components/GenericComponents/Form/SpanElement.vue'
import InputBlock from '@/components/GenericComponents/Form/InputBlock.vue'
import BasicHiddenInput from '@/components/GenericComponents/Form/BasicHiddenInput.vue'
import CustomCountrySelect from '@/components/GenericComponents/Form/CustomCountrySelect.vue'
import FormCalendar from '@/components/GenericComponents/Form/FormCalendar.vue'
import AddRemoveButtons from '@/components/GenericComponents/AddRemoveButtons.vue'
import FullScreenDayMonthInterval from '@/components/GenericComponents/Form/FullScreenDayMonthInterval.vue'
import ShowHide from '@/components/GenericComponents/Form/ShowHide.vue'

export default {
  name: 'FormGeneratorComponent',
  components: {
    BasicTextInput,
    BasicNumberInput,
    BasicCheckbox,
    BasicDateInput,
    BasicFileInput,
    BasicPasswordInput,
    BasicEmailInput,
    BasicRadioInput,
    BasicRangeInput,
    BasicSelect,
    BasicAutocomplete,
    BasicTextArea,
    BasicTimeInput,
    FormFullScreen,
    BetweenDateFullScreen,
    BetweenMinMax,
    FormSearchCustomer,
    BasicScanInput,
    InputBlockCheckbox,
    CheckboxInput,
    CustomNumberInput,
    CustomPhoneInput,
    CustomLanguageInput,
    SpanElement,
    InputBlock,
    BasicHiddenInput,
    CustomCountrySelect,
    FormCalendar,
    AddRemoveButtons,
    FullScreenDayMonthInterval,
    ShowHide
  },
  props: {
    formConfig: {
      type: Object,
      default: () => { },
      required: true
    },
    formData: {
      type: Object
    },
    lastIndex: {
      type: [Number, Object]
    },
    checkBoxUniq: {
      type: Object
    },
    checkboxChildrenValue: {
      type: [Boolean, Object]
    }
  },
  emits: ['addData', 'clear', 'delete', 'add', 'onlyOneSelectedName', 'setDefault', 'checkBoxChildrenShow', 'addElement', 'deleteElement'],
  methods: {
    /**
     * Convert params name to component name
     * @param {String} formType
     * @return {String}
     */
    formTypeToComposantName(formType) {
      switch (formType) {
        case 'text':
          return 'BasicTextInput'
        case 'number':
          return 'BasicNumberInput'
        case 'range':
          return 'BasicRangeInput'
        case 'password':
          return 'BasicPasswordInput'
        case 'date':
          return 'BasicDateInput'
        case 'radio':
          return 'BasicRadioInput'
        case 'checkbox':
          return 'BasicCheckbox'
        case 'checkbox-input':
          return 'CheckboxInput'
        case 'email':
          return 'BasicEmailInput'
        case 'file':
          return 'BasicFileInput'
        case 'time':
          return 'BasicTimeInput'
        case 'full-screen':
          return 'FormFullScreen'
        case 'full-screen-between-date':
          return 'BetweenDateFullScreen'
        case 'full-screen-between-date-birthdate':
          return 'BetweenDateFullScreen'
        case 'full-screen-min-max':
          return 'BetweenMinMax'
        case 'search-customer':
          return 'FormSearchCustomer'
        case 'select':
          return 'BasicSelect'
        case 'autocomplete':
          return 'BasicAutocomplete'
        case 'textarea':
          return 'BasicTextArea'
        case 'custom-phone':
          return 'CustomPhoneInput'
        case 'custom-language':
          return 'CustomLanguageInput'
        case 'custom-number':
          return 'CustomNumberInput'
        case 'hidden':
          return 'BasicHiddenInput'
        case 'custom-country':
          return 'CustomCountrySelect'
        case 'scan-input':
          return 'BasicScanInput'
        case 'span':
          return 'SpanElement'
        case 'date-picker':
          return 'FormCalendar'
        case 'input-block':
          return 'InputBlock'
        case 'input-block-checkbox':
          return 'InputBlockCheckbox'
        case 'day-month-interval':
          return 'FullScreenDayMonthInterval'
        case 'show-hide':
          return 'ShowHide'

        default:
          console.error(
            `Form element type ${formType} cannot be generated. Did you mean : text, number, range, password, date, radio, checkbox, email, file, time, select, textarea, custom-phone, custom-number, custom-country, hidden, span ? \n
              If you want to learn more about it, check the documentation : https://wiki.octipas.net/index.php/Formgenerator`
          )
          return null
      }
    },
    /**
     * Add specific data for children component (input-block)
     * @param {Object} field formData field
     * @return {Object}
     */
    checkSubChildren(field) {
      if (this.formConfig.hidden) {
        return { ...field, ...{ hidden: true } }
      }
      if (this.formConfig.onlyOneSelected) {
        return { ...field, ...{ onlyOneSelected: true, mainName: this.formConfig.name } }
      }
      return field
    },
    /**
     * Format data before emit for current data
     * @param {Object} data emitted data
     */
    formatAddData(data) {
      if (this.formConfig.type === 'input-block' || this.formConfig.type === 'input-block-checkbox') {
        if (this.formConfig.duplicate && !this.formConfig.duplicateIndex) {
          this.$emit('addData', { name: this.formConfig.name, value: { [data.name]: data.value }, duplicate: 0 })
        } else if (this.formConfig.duplicate && this.formConfig.duplicateIndex) {
          this.$emit('addData', {
            name: this.formConfig.name,
            value: { [data.name]: data.value },
            duplicate: this.formConfig.duplicateIndex
          })
        } else if (data.duplicateElement) {
          this.$emit('addData', {
            name: this.formConfig.name,
            value: data.value,
            duplicateElement: { name: data.name, index: data.duplicateElement }
          })
        } else {
          this.$emit('addData', { name: this.formConfig.name, value: { [data.name]: data.value } })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.input-instance-block {
  position: relative;
  display: flex;
  flex-direction: column;
}

.input-instance-block-inline {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.block-left-margin {
  margin-left: 10px;
}

.hidden {
  display: none !important;
}
</style>
